import { useCallback } from 'react';
import { Modal } from '@shared/components/Modal';
import { useToast } from '@shared/components/Toast';
import { MBGIFSearch } from '@shared/scenes/gifs/containers/search';
import { useDispatch, useSelector } from '@shared/store';
import { i18n } from '@shared/util/i18n';
import * as Actions from '../store/actions';
import { MAX_CHAT_ATTACHMENTS } from '../store/reducer';

interface Props {
  draftId: string;
}

export function ChatInputGIFModal({ draftId }: Props) {
  const dispatch = useDispatch();
  const toast = useToast();
  const visible = useSelector(state => !!state.chatInput.isGIFModalVisibleFromDraftId[draftId]);
  const close = useCallback(() => dispatch(Actions.hideGIFModal(draftId)), [dispatch, draftId]);

  const onLimitExceeded = useCallback(() => {
    toast({
      style: 'warning',
      message: i18n('chat.input.attachmentLimit.gif', { max: MAX_CHAT_ATTACHMENTS }),
      duration: 4000,
    });
  }, [toast]);

  const select = useCallback(
    (gif: MBGIF) => dispatch(Actions.selectGIF(gif, draftId, onLimitExceeded)),
    [dispatch, draftId, onLimitExceeded],
  );

  return (
    <Modal
      isOpen={visible}
      mode="modal"
      animate
      fullPage
      lightDismiss
      onOpenChange={close}
      testID="gif-modal"
    >
      <Modal.TitleBar
        title={i18n('gif.gifSearch')}
        startContent={<Modal.CloseButton onClick={close} />}
        showBorder={false}
      />
      <MBGIFSearch onSelect={select} />
    </Modal>
  );
}
